import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import sendRequest from '../../../service/sendRequest';
import { enqueueSnackbar, somethingWrongNotification } from '../../notifier/notifierActions';
import { changeConfirmed, changeId8Confirmed } from '../consumerReducer';
import { openProject } from '../../global/globalReducer';

const GET_CONSUMER_ACTIV8_DATA = 'consumer/activ8/GET_CONSUMER_ACTIV8_DATA';
const FIND_CONSUMER_ACTIV8_CONTENT = 'consumer/activ8/FIND_CONSUMER_ACTIV8_CONTENT';
const GET_CONSUMER_ACTIV8_TAGS = 'consumer/activ8/GET_CONSUMER_ACTIV8_TAGS';
const LIKE_CONSUMER_ACTIV8_CONTENT = 'consumer/activ8/LIKE_CONSUMER_ACTIV8_CONTENT';

export const getConsumerActiv8Data = createAsyncThunk(
  GET_CONSUMER_ACTIV8_DATA,
  async ({ projectName, projectPassword }, { dispatch, rejectWithValue }) => {
    const response = await sendRequest(
      () =>
        axios.post(`/api/consumer/activ8`, {
          projectName,
          projectPassword,
        }),
      {
        onError: (e) => defaultErrorHandler(e, dispatch, rejectWithValue),
      },
    );

    dispatch(changeId8Confirmed({ confirmed: true, projectName, projectPassword }));

    dispatch(openProject(projectName));

    return response.data;
  },
);

export const findConsumerActiv8Content = createAsyncThunk(
  FIND_CONSUMER_ACTIV8_CONTENT,
  async (_, { dispatch, rejectWithValue, getState }) => {
    const { page, size, searchQuery, filters } = getState().activ8.tableSettings;

    const requestBody = buildConsumerRequestBody(getState().consumer.activ8, { page, size, searchQuery, filters });
  },
);

export const findConsumerActiv8Tags = createAsyncThunk(
  GET_CONSUMER_ACTIV8_TAGS,
  async ({ query }, { dispatch, rejectWithValue, getState }) => {
    const { projectName, projectPassword } = getState().consumer.activ8;
  },
);

export const likeConsumerActiv8Content = createAsyncThunk(
  LIKE_CONSUMER_ACTIV8_CONTENT,
  async ({ id, reaction }, { dispatch, rejectWithValue, getState }) => {
    const { projectName, projectPassword } = getState().consumer.activ8;
  },
);

const defaultErrorHandler = (e, dispatch, rejectWithValue) => {
  if (e.response.status === 409) {
    dispatch(
      enqueueSnackbar({
        message: 'projectInUse',
        options: {
          variant: 'warning',
          subMessage: 'thisProjectIsCurrentlyUsing',
          subMessageParams: {
            username: e.response.data.username ?? '',
          },
        },
      }),
    );
    dispatch(changeConfirmed(false));

    return rejectWithValue(e);
  }

  dispatch(somethingWrongNotification());
  return rejectWithValue(e);
};
